import * as types from '../constants'
import { Record, List } from 'immutable'

const mapRecord = Record({
  zoom: 0,
  bounds: {},
  radius: 0,
  center: {
    lat: parseFloat(process.env.REACT_APP_DEFAULT_LAT),
    lng: parseFloat(process.env.REACT_APP_DEFAULT_LNG),
  },
  clusters: List(),
})

const initialState = new mapRecord()

export default (state = initialState, action) => {
  switch (action.type) {
    case types.MAP_CENTER_CHANGE: {
      return state.set('center', action.loc)
    }
    case types.MAP_ZOOM_CHANGE: {
      return state.set('zoom', action.zoom)
    }
    case types.CHANGE_MAP: {
      return state.merge({ zoom: action.zoom, bounds: action.bounds })
    }
    case types.GET_CLUSTERS: {
      return state.set('clusters', action.clusters)
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/map.js